export default __webpack_public_path__ + "b111235a76c249f194def6984f1a6069.png";